<template>
    <div class="row">
        <div class="col-12">
            <div class="page-title-box">
                <h4 class="page-title">Users</h4>
            </div>
        </div>
    </div>     
    <!-- end page title --> 

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-sm-5">
                            <button
                                type="button"
                                class="btn btn-danger mb-2"
                                @click="addNew()"
                            >
                                <i class="mdi mdi-plus-circle me-2"></i> Add User
                            </button>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-centered table-striped dt-responsive nowrap w-100" id="products-datatable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th style="width: 75px;">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in users.data" :key="user.id">
                                    <th scope="row">{{ user.id }}</th>
                                    <td>{{ user.name }}</td>
                                    <td>{{ user.email }}</td>
                                    <td>{{ user.type.name }}</td>
                                    <td>
                                        <edit-button class="action-icon" :id="user.id" @click="edit(user)" />
                                        <delete-button
                                            class="action-icon"
                                            :id="user.id"
                                            @click="confirnDelete(user)"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div
                            class="alert alert-primary d-flex align-middle my-auto"
                            role="alert"
                            v-if="users.data.length == 0"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                                viewBox="0 0 16 16"
                                role="img"
                                aria-label="Warning:"
                            >
                                <path
                                    d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                                />
                            </svg>
                            <div>You dont have any customers yet. Please create a new one.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
    <pagination :links="users.links" />
    <Create
        v-if="isOpen"
        @modelStatusChanged="modalStatus"
        :user="user"
        :user_types="user_types"
        :isEdit="isEdit"
    />
    <confirm-box
        v-if="showConfirmBox"
        :confirmed="deleteCustomer"
        @hidden="showConfirmBox = false"
        heading="Warning!"
        :message="deleteConfirmation"
        confirmText="Yes"
        cancelText="No"
    />
</template>
<script>

import Main from "@/Layouts/Main.vue";
import Create from "@/Pages/User/Form.vue";
import EditButton from "@/Components/EditButton.vue";
import DeleteButton from "@/Components/DeleteButton.vue";
import ConfirmBox from "@/Components/ConfirmBox.vue";
import Pagination from "@/Components/Pagination.vue";

export default {
    layout: Main,
    props: {
        auth: Object,
        errors: Object,
        user_types: Object,
        users: Array,
        flash: Object,
    },
    components: {
        Create,
        EditButton,
        DeleteButton,
        ConfirmBox,
        Pagination,
    },
    data() {
        return {
            user: null,
            isOpen: false,
            isEdit: false,
            showConfirmBox: false,
        };
    },
    methods: {
        edit(user) {
            this.user = user;
            
            this.isEdit = true;
            this.isOpen = true;
        },
        addNew () {
            this.user = null;
            
            this.isEdit = false;
            this.isOpen = true;
        },
        confirnDelete(user) {
            this.user = user;
            this.showConfirmBox = true;
        },
        modalStatus(status) {
            this.isOpen = status;
        },
        hideConfirmation() {
            this.showConfirmBox = false;
        },
        deleteUser() {
            this.$inertia.delete(
                this.route("users.destroy", this.user.id)
            );
        },
    },

    computed: {
        deleteConfirmation() {
            return `Are you sure went to delete ${this.user.name}?`;
        },
    },
    mounted() {
        this.$store.dispatch("setAuth", this.auth);

        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
    updated() {
        if (this.flash.success) {
            var toast = {
                bg: "bg-success",
                message: this.flash.success,
            };
        }
        if (toast) {
            this.$store.dispatch("showToast", toast);
        }
    },
};
</script>
